export function getDefaultWeekRange(): [Date, Date] {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const diffToMonday = (dayOfWeek + 6) % 7;
  const monday = new Date(now);
  monday.setDate(now.getDate() - diffToMonday);
  monday.setHours(0, 0, 0, 0);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  sunday.setHours(23, 59, 59, 999);

  return [monday, sunday];
}

export function getDefaultMonthRange(): [Date, Date] {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
  return [startDate, endDate];
}

export function getDateRangeForPeriod(period: string): [Date, Date] | null {
  const now = new Date();

  switch (period) {
    case "today": {
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
      return [start, end];
    }
    case "yesterday": {
      const d = new Date(now);
      d.setDate(d.getDate() - 1);
      const start = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
      const end = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
      return [start, end];
    }
    case "thisWeek":
      return getDefaultWeekRange();
    case "pastWeek": {
      const dayOfWeek = now.getDay();
      const diffToMonday = (dayOfWeek + 6) % 7;
      const monday = new Date(now);
      monday.setDate(now.getDate() - diffToMonday - 7);
      monday.setHours(0, 0, 0, 0);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      sunday.setHours(23, 59, 59, 999);
      return [monday, sunday];
    }
    case "thisMonth":
      return getDefaultMonthRange();
    case "pastMonth": {
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0);
      const end = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
      return [start, end];
    }
    case "thisQuarter": {
      const qStart = Math.floor(now.getMonth() / 3) * 3;
      const start = new Date(now.getFullYear(), qStart, 1, 0, 0, 0, 0);
      const end = new Date(now.getFullYear(), qStart + 3, 0, 23, 59, 59, 999);
      return [start, end];
    }
    case "pastQuarter": {
      let qStart = Math.floor(now.getMonth() / 3) * 3 - 3;
      let year = now.getFullYear();
      if (qStart < 0) {
        qStart += 12;
        year -= 1;
      }
      const start = new Date(year, qStart, 1, 0, 0, 0, 0);
      const end = new Date(year, qStart + 3, 0, 23, 59, 59, 999);
      return [start, end];
    }
    case "thisYear": {
      const start = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
      const end = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
      return [start, end];
    }
    case "all":
      return null;
    default:
      return null;
  }
}
